import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { TextBox, CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';

export default forwardRef(function (props, ref) {
    const [mainValue, setMainValue] = useState(props.defaultValue);

    // const changeValueTimeout = useRef();

    const onMinusClick = useCallback(
        (e) => {
            e.event?.stopPropagation();

            let newValue = parseFloat(mainValue) - 1;
            setMainValue(newValue);

            if (props.onValueChanged)
                props.onValueChanged({
                    value: parseFloat(newValue)
                });

            // if (changeValueTimeout.current) clearTimeout(changeValueTimeout.current);

            // changeValueTimeout.current = setTimeout(
            //     (_newValue, onValueChanged) => {
            //         if (onValueChanged)
            //             onValueChanged({
            //                 value: parseFloat(_newValue)
            //             });
            //     },
            //     1000,
            //     newValue,
            //     props.onValueChanged
            // );
        },
        [props.onValueChanged, mainValue]
    );

    const onPlusClick = useCallback(
        (e) => {
            e.event?.stopPropagation();

            let newValue = parseFloat(mainValue) + 1;
            setMainValue(newValue);

            if (props.onValueChanged)
                props.onValueChanged({
                    value: parseFloat(newValue)
                });
            // if (changeValueTimeout.current) clearTimeout(changeValueTimeout.current);

            // changeValueTimeout.current = setTimeout(
            //     (_newValue, onValueChanged) => {
            //         if (onValueChanged)
            //             onValueChanged({
            //                 value: parseFloat(_newValue)
            //             });
            //     },
            //     1000,
            //     newValue,
            //     props.onValueChanged
            // );
        },
        [props.onValueChanged, mainValue]
    );

    const buttons = useMemo(
        () => [
            {
                name: 'leftButton',
                location: 'before',
                options: {
                    icon: 'minus',
                    onClick: onMinusClick
                }
            },
            {
                name: 'rightButton',
                location: 'after',
                options: {
                    icon: 'plus',
                    onClick: onPlusClick
                }
            }
        ],
        [onMinusClick, onPlusClick]
    );

    const onFocusIn = useCallback((e) => {
        let inputEl = e.element.querySelector('.dx-texteditor-input');
        if (inputEl) {
            inputEl.selectionStart = 0;
            inputEl.selectionEnd = inputEl.value.length;
        }
    }, []);

    useEffect(() => {
        setMainValue(props.defaultValue);
    }, [props.defaultValue]);

    
    return (
        <React.Fragment>
            <NumberBox
                {...props}
                value={mainValue}
                inputAttr={{
                    style: 'text-align: center',
                    class: 'ant-stepper-box'
                }}
                buttons={buttons}
                onContentReady={(e) => {
                    setTimeout(() => {
                        e.component.focus();
                    }, 300);
                }}
                onFocusIn={onFocusIn}
                onEnterKey={props.onEnterKey}
            >
                {props.children}
            </NumberBox>
        </React.Fragment>
    );
});
